import { trackClickedButton } from "utils/analytics";
import { useHostLocation, useHostPageName } from "hooks/usePageViewTracker";

// What a teacher searched for is the point of the event, but it is free text:
// trimmed and capped so a pasted paragraph never travels whole.
const QUERY_MAX_LENGTH = 100;
export const analyticsQuery = (raw) => (raw || "").trim().slice(0, QUERY_MAX_LENGTH);

export const SEARCH_TYPE = { LESSON: "Lesson", STANDARD: "Standard" };
// Where each hook keeps the query of the results on screen. Read by the
// results lists, so a click on results restored from the URL reports the
// restored text.
export const SEARCH_URL_PARAM = { [SEARCH_TYPE.LESSON]: "lq", [SEARCH_TYPE.STANDARD]: "q" };
export const SEARCH_TRIGGER = { ENTER: "Enter", TYPING: "Typing" };

// One event per query the teacher ran whose response arrived.
export const trackSearchRun = ({ pageName, searchType, query, resultCount, trigger }) =>
  trackClickedButton("Search", {
    page_name: pageName,
    search_type: searchType,
    query: analyticsQuery(query),
    result_count: resultCount,
    trigger,
  });

// For a results list: one "Search Result" per click, with the 1-based position
// in the list shown.
export const useSearchResultTracking = (searchType) => {
  const pageName = useHostPageName();
  const location = useHostLocation();
  const query = location ? new URLSearchParams(location.search).get(SEARCH_URL_PARAM[searchType]) : null;
  return (position, extras) =>
    trackClickedButton("Search Result", {
      page_name: pageName,
      search_type: searchType,
      query: analyticsQuery(query),
      result_position: position,
      ...extras,
    });
};
